import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Section from '../../components/Section';
import {
  selectBeesWithIsSelected,
  selectSelectionMethod,
  setSelectionMethod,
  setSelectedBeesBasedOnSelectionMethod,
} from '../../ducks/bees';
import SelectableCard from '../../components/SelectableCard';
import { beeSelectionMethodsEnum } from '../../ducks/bees/types';
import { componentsEnum } from '../../utils/types';

export default function BeeSelectionMethod(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const presentBees = useSelector(selectBeesWithIsSelected);
  const selectionMethod = useSelector(selectSelectionMethod);
  // Only show "Red list" selectable card if there are any red list bees in this area
  const showRedListCard = presentBees.some((bee) => bee.isRedList);

  const handleClick = (selectedSelectionMethod) => {
    dispatch(setSelectionMethod(selectedSelectionMethod));
  };

  const handleNextSectionClick = async () => {
    dispatch(setSelectedBeesBasedOnSelectionMethod());
    let nextComponent;

    if (selectionMethod === beeSelectionMethodsEnum.manual) {
      nextComponent = componentsEnum.beeSelection;
    }

    if (
      selectionMethod === beeSelectionMethodsEnum.all
      || selectionMethod === beeSelectionMethodsEnum.redList
    ) {
      nextComponent = componentsEnum.plantSelectionMethod;
    }

    history.push(componentsEnum.properties[nextComponent].route);
  };

  return (
    <Section
      previousNav={{
        disabled: false,
        handleClick: () => history.push(componentsEnum.properties[componentsEnum.selectArea].route),
      }}
      nextNav={{
        disabled: selectionMethod === null,
        handleClick: handleNextSectionClick,
      }}
      {...props}
    >
      <Row className="justify-content-md-center">
        <Col className="text-center" md={10}>
          <h2>Bijenselectie</h2>
          <p>
            In het door jou geselecteerde gebied zouden volgens de modellen
            {' '}
            {presentBees.length}
            {' '}
            bijensoorten geschikt leefgebied kunnen hebben. Hoe wil je een selectie maken uit deze
            bijensoorten?
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="text-center mb-2">
          <small>Kies één van de onderstaande opties</small>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={4} className="mb-3 mb-md-0">
          <SelectableCard
            title="Handmatig"
            description="Selecteer zelf voor welke bijensoorten, die mogelijk in jouw gebied kunnen voorkomen, je een bloeiboog wilt samenstellen."
            handleClick={() => handleClick(beeSelectionMethodsEnum.manual)}
            selected={selectionMethod === beeSelectionMethodsEnum.manual}
          />
        </Col>
        { showRedListCard && (
          <Col md={4} className="mb-3 mb-md-0">
            <SelectableCard
              title="Rode lijst"
              description="Deze optie selecteert alle bijensoorten die mogelijk in jouw gebied kunnen voorkomen en die op de rode lijst staan."
              subdescription="Rode lijst bijen hebben vaak zeer specifieke habitatvereisten die mogelijk niet in de modellen zijn opgenomen. Daarom is het beheren van deze soorten moeilijk en zou het geen prioriteit moeten zijn."
              handleClick={() => handleClick(beeSelectionMethodsEnum.redList)}
              selected={selectionMethod === beeSelectionMethodsEnum.redList}
            />
          </Col>
        )}
        <Col md={4} className="mb-3 mb-md-0">
          <SelectableCard
            title="Alle bijen"
            description="Deze optie selecteert alle bijensoorten die mogelijk in het gebied kunnen voorkomen."
            handleClick={() => handleClick(beeSelectionMethodsEnum.all)}
            selected={selectionMethod === beeSelectionMethodsEnum.all}
          />
        </Col>
      </Row>
    </Section>
  );
}
